import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import store from '../store/store';

const PrivateRoute = ({ component, ...rest }: any) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (store.getState().auth.jwt) {
          return React.createElement(component, props);
        } else {
          return <Redirect to="/" />;
        }
      }}
    />
  );
};
export default PrivateRoute;
